<template>
     <v-dialog
      v-model="visible"
      max-width="600px"
      @click:outside="cancel()"
    > 
      <v-card role="alert">
        <v-card-title class="headline error--text text-center">Conferma le Informazioni</v-card-title>

        <v-card-text class="form-review" v-if="fire">
          <p><label>Nome:</label> {{ fire.name }}</p>
          <p><label>Cognome:</label> {{ fire.surname }}</p>
          <p><label>Segnalatore:</label> {{ fire.signaler }}</p>
          <p><label>Cellulare:</label> +39 {{ fire.phone }}</p>
          <p><label>Indirizzo/Località:</label> {{ fire.address }}</p>
          <p v-if="fire.streetNumber"><label>Numero civico:</label> {{ fire.streetNumber }}</p>
          <p><label>Provincia:</label> {{ fire.province }}</p>
          <p><label>Comune:</label> {{ fire.city }}</p>
          <p><label>Accensione fuoco:</label> {{ formatDate(fire.dateStart) }} 
          <svg
            class="w-4 h-4 mx-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="15"
            heigth="15"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
          {{ formatDate(fire.dateEnd) }}</p>

          <p v-if="fire.pair"><label>Abbruciamento in deroga Piano Aria:</label> sì</p>
          <p v-if="fire.deroga"><label>Dichiarazione Piano Aria<span v-if="fire.dl6923"> e zona svantaggiata FEARS</span>:</label> sì</p>

          <p v-if="fire.postalCode"><label>CAP:</label> {{ fire.postalCode }}</p>
          <p v-if="fire.notes"><label>Note aggiuntive:</label> {{ fire.notes }}</p>
          <div>
            <label>Allegati:</label> <span v-if="!files.length">Nessun allegato caricato</span>
            <ul v-else>
              <template v-for="(file, index) in files">
                <li :key="index">
                  {{file.name}} - {{bytesToMegaBytes(file.size)}}Mb
                </li>
              </template>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            class="mr-4"
            color="primary"
            @click="confirm()"
          >
            Conferma
          </v-btn>
          <v-btn
            text
            @click="cancel()"
          >
            Annulla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment";
moment.locale("it");
export default {
  name: "error-dialog",
  props: {
    fire: {
      type: Object,
      required: true
    },
    files: {
      type: Array,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('cancel');
    },
    formatDate(date) {
      if (date) {
        let mdate = moment(date);
        if (mdate && mdate.isValid()) {
          return mdate.format("DD/MM/YYYY HH:mm");
        }
      }
      return "";
    },
    bytesToMegaBytes(bytes) { 
      return Math.round((bytes / (1024*1024)) * 100) / 100; 
    },
  },
   computed: {

  },
  created() {}
};
</script>

<style scoped>
  .v-card__text div {
    font-size: 18px;
  }

  .form-review p {
    margin-bottom: 8px;
    font-size: 18px;
  }

  .form-review p label, .form-review div label {
    font-weight: bold;
  }

  li {
    font-size: 18px;
  }

</style>